import { messages } from "@/lang/messages/index";
import { aosMessages } from "@socotec.io/socio-aos-component";
import { createI18n } from "vue-i18n";
import { en, fr } from "vuetify/locale";

const allMessages = {
  en: {
    ...messages.en,
    ...aosMessages.en,
    $vuetify: en,
  },
  fr: {
    ...messages.fr,
    ...aosMessages.fr,
    $vuetify: fr,
  },
};

export default createI18n({
  legacy: false,
  locale: import.meta.env.VITE_APP_I18N_LOCALE || "fr",
  fallbackLocale: import.meta.env.VITE_APP_I18N_FALLBACK_LOCALE || "fr",
  messages: allMessages,
  silentFallbackWarn: true,
  silentTranslationWarn: true,
  missingWarn: false,
  fallbackWarn: false,
});
